import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-center pt-3 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "category-name" }, "Názov", -1)
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Popis", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_8 = { class: "mt-2 flex flex-wrap justify-content-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimevueTextArea = _resolveComponent("PrimevueTextArea")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PrimevueCard, { class: "sm:w-6 md:w-6 lg:w-5 xl:w-4" }, {
      title: _withCtx(() => [
        _createTextVNode("KATEGÓRIA")
      ]),
      subtitle: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
          name: "categoryForm"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              class: _normalizeClass(["w-full", `${$setup.v$.category.name.$error ? 'bg-red-200' : ''}`]),
              invalid: $setup.v$.category.name.$error,
              modelValue: this.category.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.category.name) = $event)),
              type: "text",
              name: "category-name",
              id: "category-name"
            }, null, 8, ["class", "invalid", "modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.category.name.$errors, (error, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "text-sm font-italic text-red-400"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_PrimevueTextArea, {
              autoResize: "",
              rows: "4",
              class: "w-full",
              placeholder: "Tu napíš popis ku kategórii",
              modelValue: this.category.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.category.description) = $event)),
              style: {"text-align":"left"},
              name: "description",
              id: "description"
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_PrimevueButton, {
              type: "submit",
              label: "Uložiť",
              text: "",
              raised: "",
              class: "uppercase"
            }),
            _createVNode(_component_router_link, { to: "/mod-stock/categories" }, {
              default: _withCtx(() => [
                _createVNode(_component_PrimevueButton, {
                  label: "Zrušiť",
                  severity: "danger",
                  text: "",
                  raised: "",
                  class: "uppercase"
                })
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    })
  ]))
}